import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const settingsIcon = createIconDefinition(
  'settings',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.1667 7.5H12.5V2.5H14.1667V4.16667H17.5V5.83333H14.1667V7.5ZM2.5 5.83333V4.16667H10.8333V5.83333H2.5ZM2.5 15.8333V14.1667H7.5V15.8333H2.5ZM10.8333 17.5V15.8333H17.5V14.1667H10.8333V12.5H9.16667V17.5H10.8333ZM5.83333 9.16667V7.5H7.5V12.5H5.83333V10.8333H2.5V9.16667H5.83333ZM17.5 10.8333V9.16667H9.16667V10.8333H17.5Z" fill="#5A42D0"/>
</svg>`,
);
